<template>
  <div class="container-fluid">
    <!-- Première carte avec titre et filtres -->
    <div class="row">
      <div class="col-12">
        <div class="card card-chart">
          <div class="card-header">
            <div class="row">
              <div class="col-12 text-left">
                <h2 class="card-title">Edition des Offres</h2>
              </div>
              <div class="col-12">
                <div class="row">
                  <div class="col-lg-3 col-md-4">
                    <base-input>
                    <el-select
                      :class="['select-primary', 'levier-select', { 'select-disabled': isGeneralMode }]"
                            v-model="selectedPositionType"
                            placeholder="POSITION"
                            :disabled="isGeneralMode"
                            @change="onPositionTypeChange"
                          >
                        <el-option
                          v-for="option in filteredPositionTypes"
                          class="select-primary"
                          :value="option.value"
                          :label="option.label.toUpperCase()"
                          :key="option.value">
                        </el-option>
                      </el-select>
                    </base-input>
                  </div>
                  <div class="col-lg-3 col-md-4">
                    <base-input>
                      <el-select
                        class="select-primary"
                        v-model="selectedProduct"
                        placeholder="PRODUIT"
                        style="width: 100%;"
                      >
                        <el-option
                          v-for="option in productOptions"
                          class="select-primary"
                          :key="option.value"
                          :label="option.label.toUpperCase()"
                          :value="option.value"
                        />
                      </el-select>
                    </base-input>
                  </div>

                  <div class="col-lg-3 col-md-4">
                    <base-input>
                      <el-date-picker
                        v-model="StartDate"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="DATE DE DÉBUT"
                        :picker-options="pickerOptions"
                      ></el-date-picker>
                    </base-input>
                  </div>
                  <div class="col-lg-3 col-md-4">
                    <base-input>
                      <el-date-picker
                        v-model="EndDate"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="DATE DE FIN"
                        :picker-options="pickerOptions"
                      ></el-date-picker>
                    </base-input>
                  </div>
                </div>
                <div class="row align-items-center mt-2">
                  <!-- Switch mode général / par levier à gauche -->
                  <div class="col-md-6 col-lg-4 d-flex align-items-center">
                    <span class="text-muted mr-2"
                          style="font-size: 0.75rem; text-transform: uppercase; letter-spacing: 0.5px; line-height: 1;">
                      VUE GÉNÉRALE
                    </span>
                    <base-switch
                      v-model="isGeneralMode"
                      type="primary"
                      on-text="ON"
                      off-text="OFF"
                    ></base-switch>
                  </div>
                  <!-- Bouton rechercher à droite -->
                  <div class="col-md-6 col-lg-8">
                    <div class="btn-group btn-group-toggle float-right">
                      <base-button
                        v-if="loading"
                        loading
                        class="btn btn-round btn-just-icon btn-primary"
                      >{{ $t("buttons.BtnLoad").toUpperCase() }}...</base-button>
                      <base-button
                        v-else
                        class="btn btn-round btn-just-icon btn-primary"
                        @click="rechercher"
                      >{{ $t("buttons.BtnSearch").toUpperCase() }}
                      </base-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Deuxième carte pour les programmes offres -->
    <div class="row">
      <div class="col-12">
        <div class="card card-chart p-4">
          <div class="card-body">
            <div v-if="loading" class="d-flex justify-content-center align-items-center" style="min-height: 300px;">
              <div class="d-flex justify-content-between align-items-center">
                <i class="fas fa-spinner fa-spin fa-2x"></i>
                <p class="px-2 text-muted mb-0">Chargement en cours</p>
              </div>
            </div>
            <div
              v-else-if="error"
              class="row w-100 d-flex justify-content-center align-items-center p-2"
              style="height: 200px"
            >
              <div
                class="h-100 d-flex justify-content-between align-items-center w-100"
              >
                <base-alert type="default" class="w-100 text-center">
                  {{error}}
                </base-alert>
              </div>
            </div>
            <div v-else>

              <div class="mb-3 d-flex justify-content-end align-items-center">
                <base-input class="mr-2" style="width: 200px; margin-bottom: 0;" v-if="!hasChanges">
                  <el-select
                    class="select-primary"
                    v-model="sortBy"
                    placeholder="Trier par"
                    @change="onSortChange"
                    clearable
                    style="width: 100%;"
                  >
                    <el-option
                      v-for="option in sortOptions"
                      class="select-primary"
                      :value="option.value"
                      :label="option.label"
                      :key="option.value">
                    </el-option>
                  </el-select>
                </base-input>
                <base-button
                  v-if="sortBy && !hasChanges"
                  class="btn-link ml-2"
                  type="market"
                  size="sm"
                  icon
                  @click="toggleSortOrder"
                  :title="sortOrder === 'desc' ? 'Trier croissant' : 'Trier décroissant'"
                >
                  <i
                    :class="
                      sortOrder === 'desc'
                        ? 'fas fa-sort-amount-down icon-large'
                        : 'fas fa-sort-amount-up icon-large'
                    "
                  ></i>
                </base-button>
                <base-button
                  class="btn-link ml-2 d-none d-md-none d-lg-flex"
                  type="market"
                  size="sm"
                  icon
                  @click="toggleDisplay"
                >
                  <i
                    :class="
                      displayGird
                        ? 'far fa-square icon-large'
                        : 'fas fa-th-large icon-large'
                    "
                  ></i>
                </base-button>
              </div>
  <!-- Mode Grid (2 colonnes) -->
  <div class="row" v-if="displayGird">
  <div
    class="col-12 col-lg-6 mb-4"
    v-for="(offre, index) in sortedOffres"
    :key="offre.id_offre"
  >
    <div
      class="offre-item mb-3 rounded shadow-sm position-relative"
      :class="{ 'dragging': draggedIndex === index }"
      :draggable="!isGeneralMode"
      @dragstart="onDragStart(index, $event)"
      @dragover.prevent="onDragOver($event)"
      @drop="onDrop(index, $event)"
      @dragend="onDragEnd"
      style="background: linear-gradient(135deg, #373761 0%, #2d2d52 100%); cursor: move; transition: all 0.3s ease;"
    >
      <!-- Numéro de position -->
      <div class="position-absolute" style="top: 0; left: 0; z-index: 10;" v-if="!isGeneralMode">
        <span class="badge position-badge position-badge-grid">
          {{ getCurrentPosition(offre) }}
        </span>
      </div>

      <!-- Nom de la campagne en haut -->
      <div class="row no-gutters border-bottom" style="border-color: rgba(255, 255, 255, 0) !important;">
        <div class="col-12 px-3 py-2" style="padding-left: 2.5rem !important;">
          <div class="d-flex flex-wrap align-items-center justify-content-start">
            <h5 class="text-white text-uppercase mb-0 mr-2 company-name-grid">
              {{ offre.provenance_programme }}
            </h5>
            <span v-if="offre.note" class="badge badge-note mr-2">
              Note: {{ offre.note }}
            </span>
            <span v-if="offre.score" class="badge badge-score">
              Score: {{ offre.score.toUpperCase() }}
            </span>
          </div>
        </div>
      </div>

      <div class="row no-gutters">
        <!-- Colonne gauche: Logo centré -->
        <div class="col-md-2 d-flex flex-column align-items-center justify-content-center px-3 py-2 border-right">
          <div class="logo-wrapper-grid d-flex align-items-center justify-content-center rounded-circle mb-2 flex-shrink-0">
            <img
              :src="offre.url_image"
              :alt="offre.provenance_programme"
              class="img-fluid"
              style="max-width: 100%; max-height: 100%; object-fit: contain;"
            />
          </div>

          <!-- <div class="d-flex flex-column align-items-center justify-content-center">
            <span v-if="offre.score" class="badge badge-score">
              Score: {{ offre.score.toUpperCase() }}
            </span>
          </div> -->
        </div>

        <!-- Colonne droite: Statistiques -->
        <div class="col-md-10 px-3 py-2 d-flex flex-column">
          <div class="row h-100 align-items-center no-gutters flex-grow-1">
            <div class="col-6 col-lg text-center stat-column">
              <span class="d-block stat-label mb-2">Clics</span>
              <div class="stat-content">
                <div class="stat-icon-wrapper d-flex align-items-center justify-content-center rounded-circle">
                  <i class="fas fa-hand-pointer"></i>
                </div>
                <span class="d-block stats-offer">{{ formatNumber(offre.total_clics || 0) }}</span>
              </div>
            </div>

            <div class="col-6 col-lg text-center stat-column">
              <span class="d-block stat-label mb-2">Leads</span>
              <div class="stat-content">
                <div class="stat-icon-wrapper d-flex align-items-center justify-content-center rounded-circle">
                  <i class="fas fa-user-check"></i>
                </div>
                <span class="d-block stats-offer">{{ formatNumber(offre.total_leads || 0) }}</span>
              </div>
            </div>

            <div class="col-6 col-lg text-center stat-column">
              <span class="d-block stat-label mb-2">CA</span>
              <div class="stat-content">
                <div class="stat-icon-wrapper d-flex align-items-center justify-content-center rounded-circle">
                  <i class="fas fa-euro-sign"></i>
                </div>
                <span class="d-block stats-offer">{{ formatAmount(offre.total_ca || 0) }}</span>
              </div>
            </div>

            <div class="col-6 col-lg text-center stat-column">
              <span class="d-block stat-label mb-2">eCPC</span>
              <div class="stat-content">
                <div class="stat-icon-wrapper d-flex align-items-center justify-content-center rounded-circle">
                  <i class="fas fa-chart-line"></i>
                </div>
                <span class="d-block stats-offer">{{ formatAmount(offre.total_ecpc || 0) }}</span>
              </div>
            </div>

            <div class="col-6 col-lg text-center stat-column">
              <span class="d-block stat-label mb-2">CPL</span>
              <div class="stat-content">
                <div class="stat-icon-wrapper d-flex align-items-center justify-content-center rounded-circle">
                  <i class="fas fa-tag"></i>
                </div>
                <span class="d-block stats-offer">{{ formatAmount(offre.cpl || 0) }}</span>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
  </div>

  <!-- Mode Normal (1 colonne) -->
  <div class="row"  v-else>
  <div
    class="col-12 mb-4"
    v-for="(offre, index) in sortedOffres"
    :key="offre.id_offre"
  >
    <div
      class="offre-item mb-3 rounded shadow-sm position-relative"
      :class="{ 'dragging': draggedIndex === index }"
      :draggable="!isGeneralMode"
      @dragstart="onDragStart(index, $event)"
      @dragover.prevent="onDragOver($event)"
      @drop="onDrop(index, $event)"
      @dragend="onDragEnd"
      style="background: linear-gradient(135deg, #373761 0%, #2d2d52 100%); cursor: move; transition: all 0.3s ease;"
    >
      <!-- Numéro de position -->
      <div class="position-absolute" style="top: 0; left: 0; z-index: 10;" v-if="!isGeneralMode">
        <span class="badge position-badge">
          {{ getCurrentPosition(offre) }}
        </span>
      </div>

      <div class="row no-gutters">
        <!-- Colonne gauche: Logo et infos -->
        <div class="col-md-5 d-flex align-items-start px-3 py-3 border-right">
          <div class="d-flex align-items-center mr-2 mt-2" style="cursor: grab;">
            <i class="tim-icons icon-drag-handle-2 text-muted" style="font-size: 1.1rem;"></i>
          </div>

          <div class="logo-wrapper d-flex align-items-center justify-content-center rounded-circle mr-3 flex-shrink-0">
            <img
              :src="offre.url_image"
              :alt="offre.provenance_programme"
              class="img-fluid"
              style="max-width: 100%; max-height: 100%; object-fit: contain;"
            />
          </div>

          <div class="flex-grow-1 min-w-0">
            <div class="mb-2">
              <h5 class="text-white text-uppercase mb-0 company-name">
                {{ offre.provenance_programme }}
              </h5>
            </div>

            <div class="d-flex flex-wrap badges-container">
              <span v-if="offre.note" class="badge badge-note mr-2 mb-1">
                Note: {{ offre.note }}
              </span>
              <span v-if="offre.score" class="badge badge-score mb-1">
                Score: {{ offre.score.toUpperCase() }}
              </span>
            </div>

            <div v-if="offre.texte_promotion" class="mt-2">
              <p class="promo-text mb-0">{{ offre.texte_promotion }}</p>
            </div>
          </div>
        </div>

        <!-- Colonne droite: Statistiques -->
        <div class="col-md-7 px-3 py-3 d-flex flex-column">
          <div class="row h-100 align-items-center no-gutters flex-grow-1">
            <div class="col-6 col-lg text-center stat-column">
              <span class="d-block stat-label mb-2">Clics</span>
              <div class="stat-content-wrapper">
                <div class="stat-content">
                  <div class="stat-icon-wrapper d-flex align-items-center justify-content-center rounded-circle">
                    <i class="fas fa-hand-pointer"></i>
                  </div>
                  <span class="d-block stats-offer">{{ formatNumber(offre.total_clics || 0) }}</span>
                </div>
                <span class="d-block stat-percentage text-muted small mt-1">{{ getPercentage(offre.total_clics || 0, totalStats.total_clics) }}%</span>
              </div>
            </div>

            <div class="col-6 col-lg text-center stat-column">
              <span class="d-block stat-label mb-2">Leads</span>
              <div class="stat-content-wrapper">
                <div class="stat-content">
                  <div class="stat-icon-wrapper d-flex align-items-center justify-content-center rounded-circle">
                    <i class="fas fa-user-check"></i>
                  </div>
                  <span class="d-block stats-offer">{{ formatNumber(offre.total_leads || 0) }}</span>
                </div>
                <span class="d-block stat-percentage text-muted small mt-1">{{ getPercentage(offre.total_leads || 0, totalStats.total_leads) }}%</span>
              </div>
            </div>

            <div class="col-6 col-lg text-center stat-column">
              <span class="d-block stat-label mb-2">CA</span>
              <div class="stat-content-wrapper">
                <div class="stat-content">
                  <div class="stat-icon-wrapper d-flex align-items-center justify-content-center rounded-circle">
                    <i class="fas fa-euro-sign"></i>
                  </div>
                  <span class="d-block stats-offer">{{ formatAmount(offre.total_ca || 0) }}</span>
                </div>
                <span class="d-block stat-percentage text-muted small mt-1">{{ getPercentage(offre.total_ca || 0, totalStats.total_ca) }}%</span>
              </div>
            </div>

            <div class="col-6 col-lg text-center stat-column">
              <span class="d-block stat-label mb-2">eCPC</span>
              <div class="stat-content">
                <div class="stat-icon-wrapper d-flex align-items-center justify-content-center rounded-circle">
                  <i class="fas fa-chart-line"></i>
                </div>
                <span class="d-block stats-offer">{{ formatAmount(offre.total_ecpc || 0) }}</span>
              </div>
            </div>

            <div class="col-6 col-lg text-center stat-column">
              <span class="d-block stat-label mb-2">CPL</span>
              <div class="stat-content">
                <div class="stat-icon-wrapper d-flex align-items-center justify-content-center rounded-circle">
                  <i class="fas fa-tag"></i>
                </div>
                <span class="d-block stats-offer">{{ formatAmount(offre.cpl || 0) }}</span>
              </div>
            </div>
          </div>

          <!-- Bouton d'expansion en bas à droite (désactivé en vue générale) -->
          <div class="d-flex justify-content-end mt-2" v-if="!isGeneralMode">
            <base-button
              @click.stop="toggleOffreDetails(offre.id_offre)"
              class="btn-link"
              type="market"
              size="sm"
              icon
              :title="isOffreExpanded(offre.id_offre) ? 'Masquer les détails' : 'Afficher les détails'"
            >
              <i :class="isOffreExpanded(offre.id_offre) ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"></i>
            </base-button>
          </div>
        </div>
      </div>
      </div>

    <!-- Tableau de détails expandable (désactivé en vue générale) -->
      <div
        v-if="!isGeneralMode && isOffreExpanded(offre.id_offre)"
        class="offre-details-container"
        style="border-top: 1px solid rgba(255, 255, 255, 0.1); background: rgba(0, 0, 0, 0.2);"
      >
        <div class="px-3 py-3">
          <!-- Message d'avertissement si la date d'aujourd'hui est sélectionnée -->
          <div v-if="todayWarningMessage" class="mb-3" style="background: linear-gradient(135deg, rgba(79, 195, 247, 0.15) 0%, rgba(79, 195, 247, 0.05) 100%); border-left: 3px solid #4FC3F7; border-radius: 4px; padding: 0.75rem 1rem; display: flex; align-items: center;">
            <i class="fas fa-star mr-2" style="font-size: 0.6rem; color: #FFC107;"></i>
            <span class="text-muted" style="font-size: 0.8rem; font-weight: 400; line-height: 1.5; letter-spacing: 0.01em;">
              {{ todayWarningMessage }}
            </span>
          </div>
          <div style="overflow-x: auto; -webkit-overflow-scrolling: touch;">
            <el-table
              :data="offre.details && offre.details.length > 0 ? offre.details : []"
              style="background: transparent; min-width: 100%;"
              :show-header="true"
              :empty-text="campagnesDetailsError || 'Aucun détail disponible'"
            >
            <el-table-column v-if="!isGeneralMode" prop="position" label="Position" min-width="80" align="center">
              <template slot-scope="scope">
                <span style="color: #ffffff; font-size: 0.9rem; text-align: center; display: block;">{{ scope.row.position || '-' }}</span>
              </template>
            </el-table-column>

            <el-table-column prop="datetime_debut" label="Date début" min-width="160" align="center">
              <template slot-scope="scope">
                <span style="color: #ffffff; font-size: 0.9rem; text-align: center; display: block;">
                  <template v-if="scope.row.datetime_debut">
                    {{ moment(scope.row.datetime_debut, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm') }}
                  </template>
                  <template v-else>-</template>
                </span>
              </template>
            </el-table-column>

            <el-table-column prop="datetime_fin" label="Date fin" min-width="160" align="center">
              <template slot-scope="scope">
                <span style="color: #ffffff; font-size: 0.9rem; text-align: center; display: block;">
                  <template v-if="scope.row.datetime_fin">
                    {{ moment(scope.row.datetime_fin, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm') }}
                  </template>
                  <template v-else>-</template>
                </span>
              </template>
            </el-table-column>

            <el-table-column prop="clics" label="Clics" min-width="80" align="center">
              <template slot-scope="scope">
                <span style="color: #ffffff; font-size: 0.9rem; text-align: center; display: block;">{{ formatNumber(scope.row.clics || 0) }}</span>
              </template>
            </el-table-column>

            <el-table-column prop="leads" label="Leads" min-width="80" align="center">
              <template slot-scope="scope">
                <span style="color: #ffffff; font-size: 0.9rem; text-align: center; display: block;">{{ formatNumber(scope.row.leads || 0) }}</span>
              </template>
            </el-table-column>

            <el-table-column prop="ca" label="CA" min-width="100" align="center">
              <template slot-scope="scope">
                <span style="color: #ffffff; font-size: 0.9rem; text-align: center; display: block;">{{ formatAmount(scope.row.ca || 0) }}</span>
              </template>
            </el-table-column>

            <el-table-column prop="ecpc" label="eCPC" min-width="100" align="center">
              <template slot-scope="scope">
                <span style="color: #ffffff; font-size: 0.9rem; text-align: center; display: block;">{{ formatAmount(scope.row.ecpc || 0) }}</span>
              </template>
            </el-table-column>

            <el-table-column prop="cpl" label="CPL" min-width="100" align="center">
              <template slot-scope="scope">
                <span style="color: #ffffff; font-size: 0.9rem; text-align: center; display: block;">{{ formatAmount(scope.row.cpl || 0) }}</span>
              </template>
            </el-table-column>

          </el-table>
          </div>
        </div>
      </div>
  </div>
  </div>

 <!-- Ligne de totaux -->
<div v-if="!loading && !error && sortedOffres.length > 0" class="row mt-5 mb-4">
  <div class="col-12">
    <div class="totals-card rounded shadow-sm">
      <div class="row h-100 align-items-center no-gutters px-4 py-4">
        <div class="col-12">
          <div class="row align-items-center justify-content-center">
            <div class="col-6 col-lg text-center stat-column">
              <span class="d-block stat-label mb-2">Clics</span>
              <div class="stat-content">
                <div class="stat-icon-wrapper totals-icon d-flex align-items-center justify-content-center rounded-circle">
                  <i class="fas fa-hand-pointer"></i>
                </div>
                <span class="d-block stats-offer totals-value">{{ formatNumber(totalStats.total_clics) }}</span>
              </div>
            </div>

            <div class="col-6 col-lg text-center stat-column">
              <span class="d-block stat-label mb-2">Leads</span>
              <div class="stat-content">
                <div class="stat-icon-wrapper totals-icon d-flex align-items-center justify-content-center rounded-circle">
                  <i class="fas fa-user-check"></i>
                </div>
                <span class="d-block stats-offer totals-value">{{ formatNumber(totalStats.total_leads) }}</span>
              </div>
            </div>

            <div class="col-6 col-lg text-center stat-column">
              <span class="d-block stat-label mb-2">CA</span>
              <div class="stat-content">
                <div class="stat-icon-wrapper totals-icon d-flex align-items-center justify-content-center rounded-circle">
                  <i class="fas fa-euro-sign"></i>
                </div>
                <span class="d-block stats-offer totals-value">{{ formatAmount(totalStats.total_ca) }}</span>
              </div>
            </div>

            <div class="col-6 col-lg text-center stat-column">
              <span class="d-block stat-label mb-2">eCPC</span>
              <div class="stat-content">
                <div class="stat-icon-wrapper totals-icon d-flex align-items-center justify-content-center rounded-circle">
                  <i class="fas fa-chart-line"></i>
                </div>
                <span class="d-block stats-offer totals-value">{{ formatAmount(totalStats.total_ecpc) }}</span>
              </div>
            </div>

            <div class="col-6 col-lg text-center stat-column">
              <span class="d-block stat-label mb-2">CPL</span>
              <div class="stat-content">
                <div class="stat-icon-wrapper totals-icon d-flex align-items-center justify-content-center rounded-circle">
                  <i class="fas fa-tag"></i>
                </div>
                <span class="d-block stats-offer totals-value">{{ formatAmount(totalStats.total_cpl) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


            </div>
          </div>
        </div>
      </div>
    </div>

    <fab
      v-if="hasChanges && !loading && !error && offres.length > 0"
      @click.native="validerPositions"
      position="bottom-right"
      main-tooltip="VALIDER LES POSITIONS"
      main-icon="check"
      icon-size="medium"
      bg-color="#004F84"
    ></fab>
  </div>
</template>

<script>
import fab from 'vue-fab'
import { Select, Option, DatePicker, Table, TableColumn } from 'element-ui'
import { BaseAlert } from "src/components"
import { BaseSwitch } from "src/components/index"
import moment from 'moment'
import axios from 'axios'
import gql from "graphql-tag";
moment.locale('fr')

export default {
  name: 'MongastonAdmin',
  components: {
    fab,
    BaseSwitch,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BaseAlert
  },
  data() {
    return {
      loading: false,
      displayGird: false,
      selectedPositionType: "position",
      selectedProduct: 'sante',
      sortBy: null,
      sortOrder: 'desc', // 'desc' pour décroissant, 'asc' pour croissant
      sortOptions: [
        { value: 'total_clics', label: 'Clics' },
        { value: 'total_leads', label: 'Leads' },
        { value: 'total_ca', label: 'CA' },
        { value: 'total_ecpc', label: 'eCPC' },
        // Pour le CPL, le champ par offre s'appelle "cpl"
        { value: 'cpl', label: 'CPL' }
      ],
      productOptions: [
        { value: 'sante', label: 'Santé' },
        { value: 'mon gaston auto', label: 'Auto' },
        { value: 'mon gaston credit conso', label: 'Crédit conso' },
        { value: 'mon gaston credit mini', label: 'Crédit mini (MB)' },
        { value: 'mon gaston eaasy credit', label: 'Easy crédit (MB)' },
        { value: 'mon gaston credit rapide', label: 'Crédit rapide (MB)' },
        { value: 'mon gaston animaux', label: 'Animaux' }
      ],
      positionTypes: [
        { value: 'position', label: 'Par défaut' },
        { value: 'position_facebook', label: 'Facebook' },
        { value: 'position_google', label: 'Google' },
        { value: 'position_bing', label: 'Bing' },
        { value: 'position_tiktok', label: 'TikTok' },
        { value: 'position_sante_actif', label: 'Santé actif' },
        { value: 'position_sante_senior', label: 'Santé sénior' },
      ],
      date_debut: moment().startOf('month').format('YYYY-MM-DD'),
      date_fin: moment().format('YYYY-MM-DD'),
      StartDate: moment().startOf('month').format('YYYY-MM-DD'),
      EndDate: moment().format('YYYY-MM-DD'),
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      draggedIndex: null,
      draggedOverIndex: null,
      offres: [],
      originalOffres: [],
      error: null,
      campagnesDetails: [],
      campagnesDetailsError: null,
      isGeneralMode: false,
      expandedOffres: new Set() // Set pour suivre les offres expandées (plus performant que Array)
    }
  },
  computed: {
    moment() {
      return moment
    },
    hasGustaveOffre() {
      if (!this.offres || this.offres.length === 0) return false

      return this.offres.some(
        offre =>
          Array.isArray(offre.tags_mon_gustave) &&
          offre.tags_mon_gustave.length > 0
      )
    },
    filteredPositionTypes() {
      // Les leviers santé_actif et santé_senior ne sont visibles que pour le produit "santé"
      if (this.selectedProduct !== 'sante') {
        return this.positionTypes.filter(option =>
          option.value !== 'position_sante_actif' &&
          option.value !== 'position_sante_senior'
        )
      }
      return this.positionTypes
    },
    sortedOffres() {
      const positionKey = this.selectedPositionType || 'position'
      const offresCopy = [...this.offres]

      // Si un critère de tri est sélectionné, trier par ce critère
      if (this.sortBy) {
        return offresCopy.sort((a, b) => {
          const valueA = parseFloat(a[this.sortBy]) || 0
          const valueB = parseFloat(b[this.sortBy]) || 0
          // Appliquer l'ordre de tri (croissant ou décroissant)
          if (this.sortOrder === 'asc') {
            return valueA - valueB // Croissant
          } else {
            return valueB - valueA // Décroissant
          }
        })
      }

      // Par défaut, trier par position (croissant)
      return offresCopy.sort((a, b) => {
        return (a[positionKey] || 0) - (b[positionKey] || 0)
      })
    },
    hasChanges() {

      if (!this.originalOffres || this.originalOffres.length === 0) {
        return false
      }

      const positionKey = this.selectedPositionType || 'position'

      for (let i = 0; i < this.offres.length; i++) {
        const currentOffre = this.offres[i]
        const originalOffre = this.originalOffres.find(o => o.id_offre === currentOffre.id_offre)

        if (!originalOffre) {
          return true
        }

        if (currentOffre[positionKey] !== originalOffre[positionKey]) {
          return true
        }
      }

      return false
    },
    totalStats() {
      if (!this.offres || this.offres.length === 0) {
        return {
          total_clics: 0,
          total_leads: 0,
          total_ca: 0,
          total_ecpc: 0,
          total_cpl: 0
        }
      }

      const totals = this.offres.reduce((acc, offre) => {
        acc.total_clics += offre.total_clics || 0
        acc.total_leads += offre.total_leads || 0
        acc.total_ca += offre.total_ca || 0
        return acc
      }, { total_clics: 0, total_leads: 0, total_ca: 0 })

      // Calculer eCPC global = CA total / Clics total
      totals.total_ecpc = totals.total_clics > 0 ? totals.total_ca / totals.total_clics : 0
      totals.total_cpl = totals.total_leads > 0 ? totals.total_ca / totals.total_leads : 0  // Ajouter cette ligne

      return totals
    },
    levier() {
      // En mode général, on ne filtre pas par levier
      if (this.isGeneralMode) {
        return null
      }

      const levierMap = {
        position: 'af',
        position_facebook: 'facebook',
        position_google: 'google',
        position_bing: 'bing',
        position_tiktok: 'tiktok',
        position_sante_actif: 'sante_actif',
        position_sante_senior: 'sante_senior'
      }

      return levierMap[this.selectedPositionType] || 'af'
    },
    todayWarningMessage() {

      if (!this.date_debut && !this.date_fin) return null

      const today = moment().format('YYYY-MM-DD')
      const startDate = moment(this.date_debut).format('YYYY-MM-DD')
      const endDate = moment(this.date_fin).format('YYYY-MM-DD')

      if (startDate === today || endDate === today) {
        return `Les données du ${moment().format('DD/MM/YYYY')} sont en cours de collecte.`
      }

      return null
    },
    gustaveTags() {
      const tags = []
      if (!this.offres || this.offres.length === 0) return tags

      this.offres.forEach(offre => {
        if (offre.tags_mon_gustave && Array.isArray(offre.tags_mon_gustave)) {
          offre.tags_mon_gustave.forEach(tag => {
            const lmClient = (tag.lm_client || '').toUpperCase()
            const nom = tag.nom_campagne || ''
            // On ne prend en compte que les tags MON GUSTAVE côté WM
            if (lmClient === 'WM' && nom && !tags.includes(nom)) {
              tags.push(nom)
            }
          })
        }
      })

      return tags
    }
  },
  apollo: {
    caByTagGustave: {
      client: "MARKET",
      query: gql` query ($tags: [String]!, $date_debut: String!, $date_fin: String!, $groupByDate: Boolean) {
        caByTag(tags: $tags, date_debut: $date_debut, date_fin: $date_fin, groupByDate: $groupByDate) {
          ca
          tag
          date
        }
      }`,
      skip() {
        return !this.hasGustaveOffre
      },
      variables() {
        return {
          date_debut: this.date_debut,
          date_fin: this.date_fin,
          tags: this.gustaveTags,
          groupByDate: true
        }
      },
      fetchPolicy: 'network-only',
      result({ data }) {
        if (!data || !data.caByTag || !this.offres || this.offres.length === 0) {
          return
        }

        // Regrouper le CA WM par tag (somme sur toutes les dates)
        const caWmByTag = data.caByTag.reduce((acc, item) => {
          const key = item.tag
          const ca = parseFloat(item.ca) || 0
          acc[key] = (acc[key] || 0) + ca
          return acc
        }, {})

        // Appliquer uniquement sur les offres avec tags_mon_gustave (Mon Gustave)
        this.offres.forEach(offre => {
          if (!offre.tags_mon_gustave || !Array.isArray(offre.tags_mon_gustave) || offre.tags_mon_gustave.length === 0) {
            return
          }

          /* // NOUVEAU : pas de tag WM → on garde le CA API, on ne recalcule pas
          const hasWmTag = offre.tags_mon_gustave.some(
            tag => (tag.lm_client || '').toUpperCase() === 'WM'
          )
          if (!hasWmTag) {
            return
          } */

          let totalCaMg = 0
          let totalCaWm = 0

          offre.tags_mon_gustave.forEach(tag => {
            const lmClient = (tag.lm_client || '').toUpperCase()
            if (lmClient !== 'WM') {
              return
            }

            const caMg = parseFloat(tag.ca_mg) || 0
            const nom = tag.nom_campagne || ''
            const caWm = caWmByTag[nom] || 0

            totalCaMg += caMg
            totalCaWm += caWm

            // Stocker le CA WM par tag si besoin ultérieurement
            tag.ca_wm = caWm
          })

          offre.total_ca_mg = totalCaMg
          offre.total_ca_wm = totalCaWm
          // CA de la carte = CA MG + CA WM
          offre.total_ca = totalCaMg + totalCaWm

          // eCPC recalculé côté front pour Mon Gustave (à partir du nouveau CA)
          const clics = offre.total_clics || 0
          offre.total_ecpc = clics > 0 ? offre.total_ca / clics : 0

          // CPL recalculé côté front pour Mon Gustave (à partir du nouveau CA)
          const leads = offre.total_leads || 0
          offre.cpl = leads > 0 ? offre.total_ca / leads : 0
        })
      }
    }
  },
  watch: {
    isGeneralMode() {
      // Quand on bascule le switch, appliquer la logique du changement de mode
      this.onModeChange()
    },
    displayGird(newVal) {
      // Si displayGird est activé, vérifier si on est sur un écran où le bouton est visible
      if (newVal) {
        this.checkScreenSize()
      }
    }
  },
  methods: {
    checkScreenSize() {
      // Le bouton est visible seulement sur lg et plus (>= 992px)
      // Si on est sur un écran plus petit, réinitialiser displayGird
      if (window.innerWidth < 992 && this.displayGird) {
        this.displayGird = false
      }
    },
    toggleDisplay() {
      this.displayGird = !this.displayGird
    },
    formatNumber(value) {
      return value.toLocaleString('fr-FR')
    },
    formatAmount(value) {
      const numValue = parseFloat(value) || 0
      return numValue.toLocaleString('fr-FR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }) + ' €'
    },
    getPercentage(value, total) {
      if (!total || total === 0) return 0
      return ((value / total) * 100).toFixed(1)
    },
    getCurrentPosition(offre) {
      const positionKey = this.selectedPositionType || 'position'
      return offre[positionKey] || offre.position
    },
    async onModeChange() {
      // Si on active la vue générale → remettre le select sur "Par défaut"
      if (this.isGeneralMode) {
        this.selectedPositionType = 'position'
      }
      // Basculer entre vue générale et vue par levier
      // Si des modifications de positions n'ont pas été validées, prévenir l'utilisateur
      if (this.hasChanges) {
        this.$notify({
          type: 'info',
          message: 'Les modifications de positions non validées ont été annulées',
          duration: 2000
        })
      }

      // Réinitialiser l'état lié au drag & drop / détails
      this.draggedIndex = null
      this.draggedOverIndex = null
      this.expandedOffres.clear()

      // Recharger les données avec ou sans levier selon le mode
      await this.rechercher()
    },
    async onPositionTypeChange() {
      if (this.isGeneralMode) {
        return
      }
      // Si on change de type de position et qu'il y a des modifications non validées,
      // restaurer les valeurs originales pour éviter la perte de modifications
      /* if (this.hasChanges && this.originalOffres && this.originalOffres.length > 0) { */
      if (this.hasChanges) {
        // Restaurer this.offres à partir de originalOffres
        this.$notify({
          type: 'info',
          message: 'Les modifications non validées ont été annulées',
          duration: 2000
        })
      }
      // Recharger les données avec le nouveau levier si on a déjà des données
        await this.rechercher()
    },
    onSortChange() {
      // Réinitialiser l'ordre de tri à décroissant par défaut
      this.sortOrder = 'desc'
    },
    toggleSortOrder() {
      // Basculer entre croissant et décroissant
      this.sortOrder = this.sortOrder === 'desc' ? 'asc' : 'desc'
    },
    toggleOffreDetails(offreId) {
      if (this.isGeneralMode) {
        return
      }
      // Toggle l'expansion d'une offre
      if (this.expandedOffres.has(offreId)) {
        this.expandedOffres.delete(offreId)
      } else {
        this.expandedOffres.add(offreId)
      }
      // Forcer la mise à jour de la vue
      this.$forceUpdate()
    },
    isOffreExpanded(offreId) {
      return this.expandedOffres.has(offreId)
    },
    async rechercher() {
      // Si aucune date n'est sélectionnée, utiliser le mois en cours jusqu'à aujourd'hui
      if (!this.StartDate && !this.EndDate) {
        this.date_debut = moment().startOf('month').format('YYYY-MM-DD')
        this.date_fin = moment().format('YYYY-MM-DD')
      } else {
        this.date_debut = this.StartDate
        this.date_fin = this.EndDate
      }

      // Vérifier si la date de début est supérieure à la date de fin
      if (this.date_debut && this.date_fin && moment(this.date_debut).isAfter(moment(this.date_fin))) {
        this.$notify({
          type: 'warning',
          message: 'La date de début ne peut pas être supérieure à la date de fin'
        })
        return
      }

      await this.fetchOffres()
    },
    async fetchOffres() {
      this.loading = true
      this.error = null
      this.offres = []
      try {
        const accessToken = localStorage.getItem("token_jwt")
        const apiUrl = "https://api-auth-plf.wee-do-it.net/api/v1/get_all_offres_v4"
        //const apiUrl = "http://localhost:8000/api/v1/get_all_offres"

        const params = {
          date_start: this.date_debut,
          date_end: this.date_fin
        }

        // N'ajouter le levier que si on n'est pas en mode général
        if (this.levier) {
          params.levier = this.levier
        }

        // Filtre produit : pour "santé" on n'envoie rien, sinon on envoie la valeur choisie
        if (this.selectedProduct && this.selectedProduct !== 'sante') {
          params.type_produit = this.selectedProduct
        }

        const response = await axios.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json"
          },
          params
        })

        if (response.data.success) {
          this.offres = response.data.data || []

          // Récupérer les détails des campagnes
          //await this.fetchCampagnesDetails()

          // Pour chaque offre, filtrer et grouper les détails correspondants depuis this.campagnesDetails
          this.offres.forEach(offre => {
            if (!offre.provenance_programme) {
              offre.details = []
              return
            }

            // Pour l'offre MON GUSTAVE SANTE, préparer le CA MG (tags_mon_gustave)
            if (offre.tags_mon_gustave && Array.isArray(offre.tags_mon_gustave) && offre.tags_mon_gustave.length > 0) {
              const totalCaMg = offre.tags_mon_gustave.reduce((sum, tag) => {
                const lmClient = (tag.lm_client || '').toUpperCase()
                if (lmClient !== 'WM') {
                  return sum
                }
                return sum + (parseFloat(tag.ca_mg) || 0)
              }, 0)

              // On stocke le CA MG cumulé (uniquement côté WM).
              // Le CA final (MG + WM) sera calculé dans caByTagGustave (Apollo),
              // qui mettra à jour offre.total_ca = totalCaMg + totalCaWm.
              offre.total_ca_mg = totalCaMg
            }

            // Filtrer les détails où nom_campagne contient provenance_programme
            const matchingDetails = offre.details || []
            /* console.log(matchingDetails.map(detail => ({
                            nom_campagne: detail.nom_campagne,
              datetime_debut: detail.datetime_debut,
              datetime_fin: detail.datetime_fin,
              position: detail.position,
              total_ca: detail.total_ca,
              total_ecpc: detail.total_ecpc,
              nombre_clics: detail.nombre_clics,
              nombre_leads: detail.nombre_leads,
            })).sort((a, b) => new Date(a.datetime_debut) - new Date(b.datetime_debut))
            ) */

            // Trier d'abord par datetime_debut (du plus ancien au plus récent)
            const sortedDetails = matchingDetails.sort((a, b) => {
              const dateA = a.datetime_debut ? moment(a.datetime_debut, 'YYYY-MM-DD HH:mm:ss') : moment(a.date, 'YYYY-MM-DD')
              const dateB = b.datetime_debut ? moment(b.datetime_debut, 'YYYY-MM-DD HH:mm:ss') : moment(b.date, 'YYYY-MM-DD')
              return dateA.diff(dateB)
            })

            // Mapper pour cumuler les positions successives (datetime_debut min, datetime_fin max)
            const cumulatedDetails = []
            for (let i = 0; i < sortedDetails.length; i++) {
              const current = sortedDetails[i]

              // Vérifier si la position précédente est la même (successive)
              if (cumulatedDetails.length > 0) {
                const lastCumulated = cumulatedDetails[cumulatedDetails.length - 1]

                // Si même position (successive)
                if (lastCumulated.position === current.position) {
                  // Mettre à jour datetime_debut (minimum)
                  if (current.datetime_debut) {
                    const currentDebut = moment(current.datetime_debut, 'YYYY-MM-DD HH:mm:ss')
                    const lastDebut = lastCumulated.datetime_debut
                      ? moment(lastCumulated.datetime_debut, 'YYYY-MM-DD HH:mm:ss')
                      : null
                    if (!lastDebut || currentDebut.isBefore(lastDebut)) {
                      lastCumulated.datetime_debut = current.datetime_debut
                    }
                  }

                  // Mettre à jour datetime_fin (maximum)
                  if (current.datetime_fin) {
                    const currentFin = moment(current.datetime_fin, 'YYYY-MM-DD HH:mm:ss')
                    const lastFin = lastCumulated.datetime_fin
                      ? moment(lastCumulated.datetime_fin, 'YYYY-MM-DD HH:mm:ss')
                      : null
                    if (!lastFin || currentFin.isAfter(lastFin)) {
                      lastCumulated.datetime_fin = current.datetime_fin
                    }
                  }

                  // Agréger les données
                  lastCumulated.nombre_clics = (lastCumulated.nombre_clics || 0) + (current.nombre_clics || 0)
                  lastCumulated.nombre_leads = (lastCumulated.nombre_leads || 0) + (current.nombre_leads || 0)
                  lastCumulated.total_ca = (lastCumulated.total_ca || 0) + (current.total_ca || 0)
                  //lastCumulated.total_ecpc = (lastCumulated.total_ecpc || 0) + (current.total_ecpc || 0)

                  continue // Ne pas ajouter cette ligne, elle est cumulée avec la précédente
                }
              }

              // Ajouter une nouvelle ligne (position différente ou première)
              cumulatedDetails.push({ ...current })
            }
            // Convertir les détails cumulés en tableau avec eCPC calculé (déjà trié et groupé par positions successives)
            const groupedDetails = cumulatedDetails.map(item => {
              const clics = item.nombre_clics || 0
              const leads = item.nombre_leads || 0
              const ca = item.total_ca || 0
              const ecpc = clics > 0 ? ca / clics : 0
              const cpl = leads > 0 ? ca / leads : 0

              return {
                position: item.position,
                date: item.date,
                datetime_debut: item.datetime_debut || null,
                datetime_fin: item.datetime_fin || null,
                clics: clics,
                leads: leads,
                ca: ca,
                ecpc: ecpc,
                cpl: cpl
              }
            })


            // Vérifier chaque ligne dans groupedDetails : si clics <= 2 et leads < 1, supprimer et ajouter les clics à la ligne précédente
            const finalDetails = []
            for (let i = 0; i < groupedDetails.length; i++) {
              const current = groupedDetails[i]

              // Vérifier si on doit supprimer cette ligne (clics <= 2 ET leads < 1)
              const shouldRemove = current.clics <= 2 && current.leads < 1

              if (shouldRemove) {
                // Si il y a une ligne précédente, ajouter les clics à cette ligne
                if (finalDetails.length > 0) {
                  const lastProcessed = finalDetails[finalDetails.length - 1]
                  // Ajouter les clics à la ligne précédente
                  /* lastProcessed.clics += current.clics
                  lastProcessed.leads += current.leads
                  // Recalculer eCPC
                  if (lastProcessed.clics > 0) {
                    lastProcessed.ecpc = lastProcessed.ca / lastProcessed.clics
                  }
                  if (lastProcessed.leads > 0) {
                    lastProcessed.cpl = lastProcessed.ca / lastProcessed.leads
                  } */
                 lastProcessed.clics += current.clics
                lastProcessed.leads += current.leads
                lastProcessed.ca += current.ca
                // Recalculer eCPC et CPL
                if (lastProcessed.clics > 0) {
                  lastProcessed.ecpc = lastProcessed.ca / lastProcessed.clics
                }
                if (lastProcessed.leads > 0) {
                  lastProcessed.cpl = lastProcessed.ca / lastProcessed.leads
                } else {
                  lastProcessed.cpl = 0
                }
                } else {
                  // Pas de ligne précédente, garder la ligne
                  finalDetails.push({ ...current })
                }
              } else {
                // Ne pas supprimer, ajouter normalement
                finalDetails.push({ ...current })
              }
            }
            // Fusionner toutes les positions identiques (même après suppression des lignes avec peu de clics)
            const mergedDetails = []
            for (let i = 0; i < finalDetails.length; i++) {
              const current = finalDetails[i]

              if (mergedDetails.length > 0) {
                const last = mergedDetails[mergedDetails.length - 1]

                // Si même position (successive après filtrage)
                if (last.position === current.position) {
                  // Mettre à jour datetime_debut (minimum)
                  if (current.datetime_debut) {
                    const currentDebut = moment(current.datetime_debut, 'YYYY-MM-DD HH:mm:ss')
                    const lastDebut = last.datetime_debut
                      ? moment(last.datetime_debut, 'YYYY-MM-DD HH:mm:ss')
                      : null
                    if (!lastDebut || currentDebut.isBefore(lastDebut)) {
                      last.datetime_debut = current.datetime_debut
                    }
                  }

                  // Mettre à jour datetime_fin (maximum)
                  if (current.datetime_fin) {
                    const currentFin = moment(current.datetime_fin, 'YYYY-MM-DD HH:mm:ss')
                    const lastFin = last.datetime_fin
                      ? moment(last.datetime_fin, 'YYYY-MM-DD HH:mm:ss')
                      : null
                    if (!lastFin || currentFin.isAfter(lastFin)) {
                      last.datetime_fin = current.datetime_fin
                    }
                  }

                  // Agréger les données
                  last.clics += current.clics
                  last.leads += current.leads
                  last.ca += current.ca

                  // Recalculer eCPC et CPL
                  if (last.clics > 0) {
                    last.ecpc = last.ca / last.clics
                  } else {
                    last.ecpc = 0
                  }
                  if (last.leads > 0) {
                    last.cpl = last.ca / last.leads
                  } else {
                    last.cpl = 0
                  }

                  // On a fusionné avec la ligne précédente, on passe à la suivante
                  continue
                }
              }

              // Nouvelle position (ou première ligne) → on démarre un nouveau bloc
              mergedDetails.push({ ...current })
            }

            offre.details = mergedDetails
          })

          // Après mise à jour des offres, forcer le recalcul du CA WM pour Mon Gustave via Apollo
          if (this.$apollo && this.$apollo.queries && this.$apollo.queries.caByTagGustave) {
            this.$apollo.queries.caByTagGustave.refetch()
          }

          // Réinitialiser les changements après récupération des données
          this.originalOffres = JSON.parse(JSON.stringify(this.offres))
          this.error = null
        } else {
          const errorMessage = response.data.message || 'Erreur lors de la récupération des données'
          this.error = errorMessage
          this.$notify({
            type: 'warning',
            message: errorMessage
          })
        }
      } catch (error) {
        console.error("Error fetching offres:", error)
        let errorMessage = 'Échec de la récupération des données. Veuillez réessayer.'
        if (error.response && error.response.data && error.response.data.message) {
          errorMessage = error.response.data.message
        } else if (error.message) {
          errorMessage = error.message
        }
        this.error = errorMessage
        this.$notify({
          type: 'danger',
          message: errorMessage
        })
      } finally {
        this.loading = false
      }
    },
    async fetchCampagnesDetails() {
      this.campagnesDetailsError = null
      try {
        const accessToken = localStorage.getItem("token_jwt")
        const apiUrl = "https://api-auth-plf.wee-do-it.net/api/v1/get_campagnes_stats_by_position"

        const response = await axios.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json"
          },
          params: {
            date_start: this.date_debut,
            date_end: this.date_fin
          }
        })

        if (response.data.success) {
          this.campagnesDetails = response.data.data || []
        }else {
          this.campagnesDetailsError = 'Un problème est survenu lors de la récupération des détails'
          this.campagnesDetails = []
        }
      } catch (error) {
        console.error("Error fetching campagnes details:", error)
        this.campagnesDetailsError = 'Un problème est survenu lors de la récupération des détails'

        // Ne pas bloquer l'utilisateur si cette API échoue
        this.campagnesDetails = []
      }
    },
    onDragStart(index, event) {
      if (this.isGeneralMode) return
      this.draggedIndex = index
      this.expandedOffres.clear()
      //this.$forceUpdate()
      event.dataTransfer.effectAllowed = 'move'
    },
    onDragOver(event) {
      if (this.isGeneralMode) return
      event.preventDefault()
    },
    onDrop(dropIndex, event) {
      if (this.isGeneralMode) return
      event.preventDefault()


      if (this.draggedIndex === null || this.draggedIndex === dropIndex) {
        return
      }

      const positionKey = this.selectedPositionType || 'position'
      const draggedItem = this.sortedOffres[this.draggedIndex]
      const dropItem = this.sortedOffres[dropIndex]

      // Modifier directement les objets (mêmes références que dans this.offres)
      const tempPosition = draggedItem[positionKey]
      draggedItem[positionKey] = dropItem[positionKey]
      dropItem[positionKey] = tempPosition

    },
    onDragEnd() {
      if (this.isGeneralMode) return
      this.draggedIndex = null
      this.draggedOverIndex = null
    },
    reorderPositions() {
      const positionKey = this.selectedPositionType || 'position'
      // Trier et réassigner les positions de 1 à N
      this.offres
        .map((offre, index) => ({ offre, index }))
        .sort((a, b) => (a.offre[positionKey] || 0) - (b.offre[positionKey] || 0))
        .forEach((item, newIndex) => {
          this.offres[item.index][positionKey] = newIndex + 1
        })
    },
    async logPositionChange(positionKey, positionsChanged, success, message) {
      try {
        const accessToken = localStorage.getItem("token_jwt")
        const logApiUrl = "https://api-auth-plf.wee-do-it.net/api/v1/log_position_change"

        const logPayload = {
          position_key: positionKey,
          changements: positionsChanged,
          success: success,
          message: message || null
        }

        await axios.post(logApiUrl, logPayload, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json"
          }
        })
      } catch (logError) {
        // Ne pas bloquer l'utilisateur si le log échoue
        console.error("Error logging position change:", logError)
      }
    },
    async validerPositions() {
      const positionKey = this.selectedPositionType || 'position'
      if (!this.hasChanges) {
        return
      }

      // Créer un tableau avec seulement les offres qui ont changé de position
      const positionsChanged = []

      this.offres.forEach(offre => {
        const originalOffre = this.originalOffres.find(o => o.id_offre === offre.id_offre)
        if (!originalOffre) return

        // Vérifier si la position a changé pour le type de position actuel
        if (originalOffre[positionKey] !== offre[positionKey]) {
          positionsChanged.push({
            id_offre: offre.id_offre,
            old_position: originalOffre[positionKey],
            nouvelle_position: offre[positionKey]
          })
        }
      })

      // Si aucune position n'a changé, ne rien faire
      if (positionsChanged.length === 0) {
        this.$notify({
          type: 'info',
          message: 'Aucune modification à sauvegarder',
          duration: 2000
        })
        return
      }

      // Appeler l'API pour sauvegarder les positions
      try {
        this.loading = true
        const accessToken = localStorage.getItem("token_jwt")
        const apiUrl = "https://api-auth-plf.wee-do-it.net/api/v1/change_offer_position"

        const payload = {
          offres: positionsChanged,
          positionkey: positionKey
        }

        // Filtre produit : pour "santé" on n'envoie rien, sinon on envoie la valeur choisie
        if (this.selectedProduct && this.selectedProduct !== 'sante') {
          payload.type_produit = this.selectedProduct
        }

        const response = await axios.post(apiUrl, payload, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json"
          }
        })

        if (response.data.success) {
          const successMessage = response.data.message || 'Positions mises à jour avec succès'

          // Logger le succès
          await this.logPositionChange(positionKey, positionsChanged, true, successMessage)

          this.$notify({
            type: 'success',
            message: successMessage,
            duration: 3000
          })
          // Réinitialiser le tri après validation
            this.sortBy = null
            this.sortOrder = 'desc'

          // Mettre à jour les offres originales après validation
          //this.originalOffres = JSON.parse(JSON.stringify(this.offres))

          // Recharger les données pour avoir les positions à jour
          await this.fetchOffres()
        } else {
          const errorMessage = response.data.message || 'Erreur lors de la mise à jour des positions'
          const message = 'Une erreur est survenue lors de la mise à jour des positions.'

          // Logger l'erreur
          await this.logPositionChange(positionKey, positionsChanged, false, errorMessage)

          this.$notify({
            type: 'warning',
            message: message
          })
        }
      } catch (error) {
        console.error("Error updating positions:", error)
        let errorMessage = 'Échec de la mise à jour des positions. Veuillez réessayer.'
        const message = errorMessage
        if (error.response && error.response.data && error.response.data.message) {
          errorMessage = error.response.data.message
        } else if (error.message) {
          errorMessage = error.message
          }

        // Logger l'erreur
        await this.logPositionChange(positionKey, positionsChanged, false, errorMessage)

        this.$notify({
          type: 'warning',
          message: message
        })
      } finally {
        this.loading = false
      }
    }
  },
  mounted() {
    // Appeler l'API au chargement du composant
    this.fetchOffres()

    // Vérifier la taille d'écran au chargement
    this.checkScreenSize()

    // Écouter les changements de taille d'écran
    window.addEventListener('resize', this.checkScreenSize)
  },
  beforeDestroy() {
    // Nettoyer le listener au démontage du composant
    window.removeEventListener('resize', this.checkScreenSize)
  }
}
</script>

<style scoped>
.offre-item {
  padding: 0 !important;
  border: 1px solid rgba(255, 255, 255, 0.05);
  overflow: hidden;
}

.offre-item:hover {
  box-shadow: 0 8px 24px rgba(0, 79, 132, 0.25) !important;
  transform: translateY(-2px);
}

.border-right {
  border-right: 1px solid rgba(255, 255, 255, 0.08) !important;
}

.position-badge {
  background: linear-gradient(135deg, #F4A261 0%, #E76F51 100%) !important;
  color: #f6f6fc !important;
  font-weight: 700;
  font-size: 0.6rem;
  padding: 0.4rem 0.8rem;
  border-radius: 0 0 8px 0;
  min-width: 40px;
  text-align: center;
  display: inline-block;
  box-shadow: 0 2px 8px rgba(244, 162, 97, 0.3);
}

.position-badge-grid {
  font-size: 0.6rem !important;
  padding: 0.25rem 0.6rem !important;
  min-width: 30px !important;
  box-shadow: 0 1px 4px rgba(244, 162, 97, 0.25) !important;
}

.badge-note {
  background: linear-gradient(135deg, #2A9D8F 0%, #1D7874 100%) !important;
  color: #ffffff !important;
  font-weight: 600;
  font-size: 0.75rem;
  padding: 0.3rem 0.6rem;
  border-radius: 6px;
  box-shadow: 0 2px 6px rgba(42, 157, 143, 0.25);
}

.badge-score {
  background: linear-gradient(135deg, #9B59B6 0%, #8E44AD 100%) !important;
  color: #ffffff !important;
  font-weight: 600;
  font-size: 0.75rem;
  padding: 0.3rem 0.6rem;
  border-radius: 6px;
  box-shadow: 0 2px 6px rgba(155, 89, 182, 0.25);
}

.dragging {
  opacity: 0.5;
  border: 2px dashed #004F84 !important;
}

.stats-offer {
  font-size: 0.9rem;
  font-weight: 700;
  background: linear-gradient(135deg, #ffffff 0%, #e0e0e0 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  line-height: 1.2;
}

.stat-icon-wrapper {
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, rgba(0, 79, 132, 0.2) 0%, rgba(0, 79, 132, 0.05) 100%);
  border: 1px solid rgba(0, 79, 132, 0.3);
  flex-shrink: 0;
}

.stat-icon-wrapper i {
  font-size: 0.85rem;
  color: #4FC3F7;
}

.stat-label {
  font-size: 0.65rem;
  font-weight: 700;
  letter-spacing: 0.5px;
  color: #8e8ea1;
  text-transform: uppercase;
  margin-bottom: 0.15rem;
}

.logo-wrapper {
  width: 65px;
  height: 65px;
  padding: 8px;
  background: linear-gradient(135deg, #ffffff 0%, #f5f5f5 100%);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  margin-top: 8px;
}
.logo-wrapper-grid {
  width: 55px;
  height: 55px;
  padding: 6px;
  background: linear-gradient(135deg, #ffffff 0%, #f5f5f5 100%);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.company-name-grid {
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.3px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  line-height: 1.3;
  word-break: break-word;
}

.company-name {
  font-size: 0.9rem;
  font-weight: 700;
  letter-spacing: 0.3px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  line-height: 1.3;
  margin-top: 8px;
}

.promo-text {
  font-size: 0.8rem;
  color: #b8b8c5;
  line-height: 1.4;
}

.stat-column {
  min-width: 0;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.stat-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

/* @media (max-width: 991px) {
  .stat-column {
    margin-bottom: 0.75rem;
  }

  .stat-column:last-child {
    margin-bottom: 0;
  }
} */

@media (max-width: 991px) {
  .badges-container {
    display: none !important;
  }

  .border-right {
    border-right: none !important;
    border-bottom: none !important;
  }

  /* Réorganiser les colonnes en mobile */
  .offre-item .row.no-gutters {
    flex-direction: column;
  }

  .offre-item .col-md-5,
  .offre-item .col-md-7 {
    max-width: 100%;
    flex: 0 0 100%;
  }

  /* Stats en lignes complètes */
  .stat-column {
    flex: 0 0 100% !important;
    max-width: 100% !important;
    padding: 0.5rem 1rem !important;
    margin-bottom: 0 !important;
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  }

  .stat-column:last-child {
    border-bottom: none;
  }

  .stat-content {
    justify-content: space-between !important;
    padding: 0.25rem 0;
  }

  .stat-label {
    display: none !important;
  }

  .stats-offer {
    font-size: 0.9rem;
    margin-left: auto;
  }

  .stat-icon-wrapper {
    width: 28px;
    height: 28px;
  }

  .stat-icon-wrapper i {
    font-size: 0.7rem;
  }

  .logo-wrapper {
    width: 50px;
    height: 50px;
  }

  .company-name {
    font-size: 0.85rem;
  }

  /* Section stats avec bordure en haut */
  .col-md-7.px-3.py-3 {
    border-top: 1px solid rgba(255, 255, 255, 0.08);
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  .col-md-7 .row {
    flex-direction: column !important;
  }
  /* Styles pour la ligne de totaux */
.totals-card {
  background: linear-gradient(135deg, #2a2a47 0%, #1f1f35 100%);
  border: 2px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 4px 16px rgba(0, 79, 132, 0.4);
}

.totals-label-wrapper {
  border-right: 1px solid rgba(255, 255, 255, 0.1);
}

.totals-title {
  color: #ffffff;
  font-weight: 700;
  font-size: 1rem;
  letter-spacing: 0.5px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.totals-title i {
  color: #4FC3F7;
}

.totals-icon {
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0.05) 100%);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.totals-value {
  font-size: 1rem;
  font-weight: 800;
}

@media (max-width: 991px) {
  .totals-label-wrapper {
    border-right: none;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }

  .totals-title {
    font-size: 0.9rem;
    text-align: center;
  }
}
}
/* Style pour le select levier désactivé UNIQUEMENT en mode général */
.levier-select.select-disabled .el-input__inner {
  background-color: #2b2b4a !important;
  cursor: not-allowed !important;
  opacity: 0.5 !important;
  color: #8e8ea1 !important;
  border-color: rgba(255, 255, 255, 0.1) !important;
}

.levier-select.select-disabled .el-input__suffix {
  opacity: 0.5 !important;
}

.levier-select.select-disabled .el-select__caret {
  color: #8e8ea1 !important;
}
.stat-percentage {
  font-size: 0.85rem;
  opacity: 0.8;
  line-height: 1.2;
}

@media (max-width: 768px) {
  .stat-percentage {
    font-size: 0.85em;
  }
}

</style>
